import Client from "./client";

const baseUrl = `/api/1`;

function order() {
  return {
    getListActive: ({ params }) => {
      const url = !!params.queryParams
        ? baseUrl +
          `/orders/self/active/${params.pageSize}/${params.pageNumber}?${params.queryParams}`
        : baseUrl +
          `/orders/self/active/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
    getListAll: ({ params }) => {
      const url = !!params.queryParams
        ? baseUrl +
          `/doneOrders/self/all/${params.pageSize}/${params.pageNumber}?${params.queryParams}`
        : baseUrl +
          `/doneOrders/self/all/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
    getListDone: ({ params }) => {
      const url = !!params.queryParams
        ? baseUrl +
          `/doneOrders/self/done/${params.pageSize}/${params.pageNumber}?${params.queryParams}`
        : baseUrl +
          `/doneOrders/self/done/${params.pageSize}/${params.pageNumber}`;

      return Client.get(url);
    },
    cancelOrderById: ({ params }) => {
      const url = baseUrl + `/orders/cancel/${params.id}`;
      return Client.put(url);
    },

    cancelAllOrders: () => {
      const url = baseUrl + `/orders/cancel/all`;
      return Client.put(url);
    },

    getMarketOrderBook: ({ params }) => {
      const url = baseUrl + `/orders/orderBook/market/${params.market}`;
      return Client.getWithoutLoading(url);
    },

    getMarketOrderBook1: ({ params }) => {
      const url = baseUrl + `/orders/orderBook/market/size/${params.market}/16`;
      return Client.getWithoutLoading(url);
    },
    postOrder: ({ payload }) => {
      const url = baseUrl + `/orders`;
      return Client.post(url, payload);
    },
    getMyActiveOrdersByMarketName: ({ params }) => {
      const url =
        baseUrl +
        `/orders/self/marketname/${params.marketname}/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
  };
}

export default order();
